// Версия для UI: <semver>+<git-sha>. Берём из import.meta.env.VITE_APP_VERSION,
// которую vite.config.ts выставляет в process.env при старте dev-сервера/build.

export const APP_VERSION: string =
  (import.meta.env.VITE_APP_VERSION as string | undefined) ?? 'dev';
